import React from "react";
import { Layout } from 'antd';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';
import useGetCurrentWebsite from "../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite";
import VisibilityAnalysis from "../visibilityAnalysis/VisibilityAnalysis";

const { Content } = Layout;


export default function LLMVisibilityAnalysisPage() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const domain = selectedWebsite?.domain || "";

    return (
        <Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                {domain ? <VisibilityAnalysis domain={domain} /> : null}
            </WebsiteIndexEntryTabs>
        </Content>
    );
}